// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2tUdU","insightsList":"newBusinessInsightsMenu_insightsList__1CPiw","active":"newBusinessInsightsMenu_active__1bddP"};